angular.module('dealerware.web.data').factory('DealerwareLocationSettingsModel', function ($q, Model) {
    var model = new Model({
        baseEndpoint: '/locations/:location_id/settings',
        customActions: {
            get: {
                method: 'GET',
                ignoreAssociations: true
            }
        }
    });

    return model;
});
